import { createRouter } from '@tanstack/react-router';
import { getLogger } from '@logging/logger';
import { loggingConfig } from '@api/auth/config';

// Import the generated route tree
import { routeTree } from './routeTree.gen';

// Create a new router instance
export const router = createRouter({
  routeTree,
});

if (loggingConfig.logRouteChanges) {
  router.subscribe('onResolved', ({ fromLocation, toLocation }) => {
    getLogger().info('route changed', {
      from: fromLocation?.pathname,
      to: toLocation.pathname,
    });
  });
}

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
